import zod from 'zod'

export const schema = zod.object({
  name: zod
    .string({ required_error: 'Obrigatório' })
    .min(3, 'Deve ter no mínimo 3 letras'),
  email: zod
    .string({ required_error: 'Obrigatório' })
    .email('Deve ser um e-mail válido'),
  password: zod
    .string()
    .trim()
    .optional()
    .transform((data) => (!data?.length ? undefined : data))
    .refine((data) => !(data?.length && data.length < 8), {
      message: 'Deve ter no mínimo 8 caracteres',
    }),
})

export type UpdateAdminFormType = zod.infer<typeof schema>
